import { Component, Input } from '@angular/core';
import { Cartridge } from '@markant-platform/cartridge/model';

@Component({
  selector: 'markant-platform-cartridge-grid',
  templateUrl: './cartridge-grid.component.html',
  styleUrls: ['./cartridge-grid.component.scss'],
})
export class CartridgeGridComponent {
  // TODO: rename to "similarCartridges" as soon as they are available
  @Input() cartridges: Cartridge[] = [];
  @Input() columnCount = 2;

  // Helps to display an empty element to fill grid gaps
  getGapFillCondition(odd: boolean, even: boolean): boolean {
    const columnCountOdd = this.columnCount % 2 === 0;
    const columnCountEven = this.columnCount % 2 !== 0;

    return (odd && columnCountEven) || (even && columnCountOdd);
  }
}
